import api from '../../plugins/api';

// GET /api/crm/onboarding — что сотрудник уже прошёл в обучении.
const getOnboarding = () => {
  return api.get('/api/crm/onboarding');
};

export default getOnboarding;
